module.exports = __webpack_public_path__ + "static/media/Healthcheck.0d4ec512.webp";